import React from "react";

export default function Promotion() {
  return <div></div>;
}
